module.exports = __webpack_public_path__ + "static/media/icon_navigate.c5101512.svg";